import { Pipe, PipeTransform } from "@angular/core";
import { DecoStoreService } from "@app/stores/deco.store";
import { map, Observable } from "rxjs";

@Pipe({
    name: "purposeName",
    standalone: true,
})
export class PurposeNamePipe implements PipeTransform {
    constructor(private decoStoreService: DecoStoreService) {}

    transform(value: any, ispublic: boolean = false): Observable<string> {
        if (ispublic)
            return this.decoStoreService
                .getPurposesPublic()
                .pipe(map((res) => res.find((x) => x.value === value)?.text || ""));
        else
            return this.decoStoreService
                .getPurposes()
                .pipe(map((res) => res.find((x) => x.value === value)?.text || ""));
    }
}
